import { useState } from 'react';
import { UseFormRegister, UseFormSetValue, UseFormWatch, Controller, Control } from 'react-hook-form';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import Switch from './ui/switch';
import Input from './ui/input';
import { Textarea } from './ui/textarea';

interface InputEnProps {
  nama: string;
  namaEn: string;
  placeholder?: string;
  type?: 'text' | 'textarea' | 'texteditor' | 'texteditor_isDirty';
  required?: boolean;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  control?: any;
}
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link'],
    ['clean'],
    [{ direction: 'rtl' }],
  ],
};

export default function InputEn({
  nama,
  namaEn,
  register,
  placeholder,
  type = 'text',
  setValue,
  watch,
  required,
  control,
}: InputEnProps) {
  const [isEnglish, setIsEnglish] = useState(false);

  const renderInputField = (name: string) => {
    if (type === 'texteditor') {
      return (
        <ReactQuill
          value={watch(name) || ''}
          onChange={(content) => setValue(name, content)}
          theme="snow"
          className="mt-2 text-sm"
          modules={modules}
        />
      );
    }
    if (type === 'texteditor_isDirty') {
      return (
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <ReactQuill
              value={field.value || ''}
              onChange={(content) => field.onChange(content)}
              theme="snow"
              className="text-base z-50"
            />
          )}
        />
      );
    }
    if (type === 'textarea') {
      return (
        <Textarea
          {...register(name)}
          placeholder={placeholder}
          className="h-32 w-full rounded-md border px-3 py-2 text-sm resize-none"
          required={required || true}
        />
      );
    }
    return <Input {...register(name)} placeholder={placeholder} required={required || true} />;
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2 border p-2 rounded-md bg-gray-100">
        <div className="flex items-center gap-2">
          {isEnglish ? (
            <>
              <img src="/assets/gb.svg" alt="inggris" className="w-5" />
              <span className="text-sm font-medium">English</span>
            </>
          ) : (
            <>
              <img src="/assets/id.svg" alt="indonesia" className="w-5" />
              <span className="text-sm font-medium">Bahasa Indonesia</span>
            </>
          )}
        </div>
        <Switch checked={isEnglish} onCheckedChange={setIsEnglish} />
      </div>

      {!isEnglish && <div>{renderInputField(nama)}</div>}
      {isEnglish && <div>{renderInputField(namaEn)}</div>}
    </div>
  );
}
